import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../constants/componentTypes";
import * as navigationActions from "../../../actions/navigationActions";
import * as rccActions from "../../../actions/rccActions";
import * as modelHelper from "../../../helpers/modelHelper";
import * as formatHelper from "../../../helpers/formatHelper";
import * as conversionHelper from "../../../helpers/conversionHelper";

import Modal, {MODAL_VARIANT_WARNING} from "../generic/Modal";
import Button, {BUTTON_SMALL} from "../generic/Button";

class CheckBeforeDispensingModal extends Component {
    componentDidUpdate() {
        if (
            this.props.params.realColorantList
                .map((colorant) => {
                    let canister = this.props.canisterList.find((canister) => {
                        return colorant.name === canister.colorant?.name;
                    });

                    return {
                        amountToDispense:
                            conversionHelper.convertAmountByColorant(
                                colorant,
                                colorant.amountType,
                                this.props.machineUnit
                            ) * this.props.params.numCanToDispense,
                        currentCanisterLevel: canister !== undefined ? canister.currentLevel : 0,
                        maxCanisterLevel: canister !== undefined ? canister.capacity : 0,
                        minimumLevel: canister !== undefined ? canister.minimumLevel : 0
                    };
                })
                .filter((colorant) => {
                    return colorant.amountToDispense > colorant.currentCanisterLevel - colorant.minimumLevel;
                }).length === 0
        ) {
            this.props.dispatchAction(this.props.params.next);
            this.props.dispatchCloseModalAction();
        }
    }
    handleCloseModal = () => {
        this.props.dispatchCloseModalAction();
    };
    handleRefillCanister = (index) => {
        this.props.dispatchRefillCanisterAction(index);
    };

    getContent() {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-12 flex flex-wrap padding-bottom-10">
                    {this.props.params.realColorantList
                        .map((colorant) => {
                            let canister = this.props.canisterList.find((canister) => {
                                return colorant.name === canister.colorant?.name;
                            });

                            return {
                                amountToDispense:
                                    conversionHelper.convertAmountByColorant(
                                        colorant,
                                        colorant.amountType,
                                        this.props.machineUnit
                                    ) * this.props.params.numCanToDispense,
                                currentCanisterLevel: canister !== undefined ? canister.currentLevel : 0,
                                displayName: colorant.displayName,
                                rgb: colorant.rgb,
                                maxCanisterLevel: canister !== undefined ? canister.capacity : 0,
                                minimumLevel: canister !== undefined ? canister.minimumLevel : 0,
                                id: colorant.id,
                                index: canister !== undefined ? canister.id : 0,
                                unit: colorant.amountType
                            };
                        })
                        .filter((colorant) => {
                            return colorant.amountToDispense > colorant.currentCanisterLevel - colorant.minimumLevel;
                        })
                        .map((colorant) => {
                            return (
                                <div
                                    className="col-12 flex flex-wrap flex-align-center-vertical padding-10"
                                    key={colorant.id}
                                >
                                    <div
                                        className="color-square"
                                        style={{
                                            backgroundColor: colorant.rgb,
                                            height: "25px",
                                            width: "25px"
                                        }}
                                    />
                                    <span className="font-size-1_75em padding-right-10">{colorant.displayName}</span>
                                    {colorant.minimumLevel + colorant.amountToDispense > colorant.maxCanisterLevel ? (
                                        <Translate
                                            className="font-size-1_75em color-primary"
                                            value="checkBeforeDispensing.refillToMax"
                                        />
                                    ) : (
                                        <div>
                                            <Translate
                                                className="padding-right-10"
                                                value="checkBeforeDispensing.fillAdditionally"
                                            />
                                            <span className="font-size-1_75em color-primary">
                                                {formatHelper.formatDecimal(
                                                    colorant.amountToDispense -
                                                        (colorant.currentCanisterLevel - colorant.minimumLevel)
                                                )}
                                                {" " + this.props.machineUnit}
                                            </span>
                                        </div>
                                    )}

                                    <Button
                                        className="flex-right"
                                        size={BUTTON_SMALL}
                                        label={translate("general.refill")}
                                        onClick={() => this.handleRefillCanister(colorant.index)}
                                        disabled={this.props.machine.isBusy}
                                    />
                                </div>
                            );
                        })}
                </div>
            </React.Fragment>,
            "flex-row-gap-10px flex-wrap slim-scroll col-12"
        );
    }
    getFooter() {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-12 color-black font-size-0_75em">
                    <Translate value="help.continue" />
                </div>
                <Button className="padding-right-5" label="Abort" onClick={this.handleCloseModal} />
                <Button
                    label={translate("help.formulaValidation.warningConfirmBtn")}
                    onClick={() => {
                        this.props.dispatchAction(this.props.params.next);
                        this.props.dispatchCloseModalAction();
                    }}
                />
            </React.Fragment>,
            "col-12 flex flex-wrap flex-align-center-vertical"
        );
    }

    render() {
        return (
            <Modal
                variant={MODAL_VARIANT_WARNING}
                modlId={this.props.id}
                onClose={this.handleCloseModal}
                header={modelHelper.buildModalSection(<Translate value="general.warning" />)}
                subHeader={modelHelper.buildModalSection(
                    <Translate
                        numOfPackages={this.props.params.numCanToDispense}
                        value="checkBeforeDispensing.checkBeforeDispensingModal"
                    />
                )}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{minWidth: "60%"}}
                topModalOff={true}
            />
        );
    }
}
const mapStoreToProps = (store) => {
    return {
        machine: store.rcc.machine,
        canisterList: store.rcc.canisterList,
        machineUnit: store.rcc.machineConfigurationList.unit
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.CHECK_BEFORE_DISPENSING_MODAL));
        },
        dispatchRefillCanisterAction: (index) => {
            dispatch(rccActions.startCanisterRefill(index));
        },
        dispatchAction: (action) => {
            dispatch(action);
        }
    };
};

export default CheckBeforeDispensingModal = connect(mapStoreToProps, mapDispatchToProps)(CheckBeforeDispensingModal);
